import { CivilSearchTier, Outcome, RequestStatus, RequestType, UtilityPresence } from './types';

// if any of these values change, please update the backend civilsearch.ts in common
export const requestStatusLabels: { [key in RequestStatus]: string } = {
  [RequestStatus.Pending]: 'In Queue',
  [RequestStatus.InProgress0]: 'In Progress',
  [RequestStatus.InProgress1]: 'In Progress (Follow-up 1)',
  [RequestStatus.InProgress2]: 'In Progress (Follow-up 2)',
  [RequestStatus.InProgress3]: 'In Progress (Final Follow-up)',
  [RequestStatus.ActionRequired]: 'Action Required',
  [RequestStatus.OnHoldPerAgency]: 'On Hold (Per Agency)',
  [RequestStatus.Complete]: 'Complete',
  [RequestStatus.Cancelled]: 'Cancelled',
  [RequestStatus.Dismissed]: 'Dismissed',
};

export const utilitiesPresentLabels: { [key in UtilityPresence]: string } = {
  [UtilityPresence.Present]: 'Present',
  [UtilityPresence.NoAssetsPresent]: 'No Assets Present',
  [UtilityPresence.PresenceUnknown]: 'Presence Unknown',
  [UtilityPresence.OutsideServiceArea]: 'Outside Service Area',
};

export const outcomeLabels: { [key in Outcome]: string } = {
  [Outcome.DocumentsReceived]: 'Documents Received',
  [Outcome.AgencyResponded]: 'Agency Responded',
  [Outcome.AgencyNotSharing]: 'Agency Not Sharing',
  [Outcome.AgencyUnresponsive]: 'Agency Unresponsive',
  [Outcome.ReferredToOtherAgency]: 'Referred to other Agency',
};

export const requestTypeMap: { [key: string]: string } = {
  [RequestType.MapsRequested]: 'Maps Requested',
  [RequestType.AsbuiltsRequested]: 'As-Builts Requested',
};

export const requestTypeLabelMap: { [key: string]: string } = {
  [RequestType.MapsRequested]: 'Maps',
  [RequestType.AsbuiltsRequested]: 'As-Builts',
};

export const civilSearchTierLabels: { [key in CivilSearchTier]: string } = {
  [CivilSearchTier.Tier1]: 'Tier 1',
  [CivilSearchTier.Tier2]: 'Tier 2',
  [CivilSearchTier.Tier3]: 'Tier 3',
  [CivilSearchTier.Tier4]: 'Tier 4',
  [CivilSearchTier.Tier5]: 'Tier 5',
};

export type BillingTier = 'draft' | 'proposal' | 'project' | 'projectPlus';

export const billingTierLabels: { [key in BillingTier]: string } = {
  draft: 'Draft',
  proposal: 'Proposal',
  project: 'Project',
  projectPlus: 'Project +',
};
